var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"id":"larabergEditor","name":"larabergEditor","hidden":""},domProps:{"value":_vm.value},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }